import { useTranslation } from 'react-i18next';

import type { EquipmentInventoryStatusData } from '../../model';

export const useEquipmentInventoryStatuses = () => {
    const { t } = useTranslation();

    const inventoryStatusesData: EquipmentInventoryStatusData[] = [
        {
            status: 0,
            text: t('inventory.status.text.inWork'),
            color: '#C4CCD7',
            icon: 'inWorkIcon',
        },
        {
            status: 1,
            text: t('inventory.status.text.free'),
            color: '#2AB96B',
            icon: 'freeIcon',
        },
        {
            status: 2,
            text: t('inventory.status.text.broken'),
            color: '#EC0818',
            icon: 'brokenIcon',
        },
        {
            status: 3,
            text: t('inventory.status.text.decommissioned'),
            color: '#8A0000',
            icon: 'decommissionIcon',
        },
    ];

    return { inventoryStatusesData };
};
